export const BUSINESS_TYPES = [
  { value: "LIMITED_LIABILITY", label: "Limited Liability Company" },
  { value: "PUBLIC_LIMITED", label: "Public Limited Company" },
  { value: "SOLE_PROPRIETORSHIP", label: "Sole Proprietorship" },
  { value: "PARTNERSHIP", label: "Partnership" },
  { value: "NGO", label: "NGO / Non-profit" },
  { value: "GOVERNMENT", label: "Government / Parastatal" },
  { value: "OTHER", label: "Other" },
] as const;

export const EMPLOYEE_COUNT_RANGES = [
  "1-10",
  "11-50",
  "51-200",
  "201-500",
  "500+",
] as const;

export const DOCUMENT_TYPES = [
  { value: "CAC_CERTIFICATE", label: "CAC Certificate" },
  { value: "CAC_STATUS_REPORT", label: "CAC Status Report" },
  { value: "MEMART", label: "MEMART" },
  { value: "TAX_CLEARANCE", label: "Tax Clearance" },
  { value: "UTILITY_BILL", label: "Utility Bill" },
  { value: "OTHER", label: "Other related document" },
] as const;

export const NIGERIA_STATES = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
] as const;

export type BusinessTypeValue = (typeof BUSINESS_TYPES)[number]["value"];
export type EmployeeCountRangeValue = (typeof EMPLOYEE_COUNT_RANGES)[number];
export type DocumentTypeValue = (typeof DOCUMENT_TYPES)[number]["value"];
export type NigeriaStateValue = (typeof NIGERIA_STATES)[number];
